<section>
  <span class="node-name-header">{{ dashboardName$ | async }}</span>
  <div class="dashboard-buttons">
    @if (allowEdit && showTemplateSelect()) {
      <app-dashboard-templates-select
        data-cy="dashboard-templates-select"
      ></app-dashboard-templates-select>
    }
    @if (showDownload()) {
      <app-dropdown [customStyles]="dropDownStyles" position="right">
        <button
          [disabled]="isDownloading"
          mat-flat-button
          class="button-primary dropdown-button"
          data-cy="dashboard-download-as"
        >
          <mat-icon svgIcon="download"></mat-icon>
          {{ 'DOWNLOAD_AS' | translate }}...
        </button>
        @if (!isDownloading) {
          <ng-container body>
            <a
              (click)="downloadPng()"
              (keydown.enter)="downloadPng()"
              (keydown.space)="downloadPng()"
              data-cy="download-as-png"
              tabindex="0"
            >
              <mat-icon svgIcon="image"></mat-icon>
              PNG
            </a>
            <a
              (click)="downloadCsv()"
              (keydown.enter)="downloadCsv()"
              (keydown.space)="downloadCsv()"
              data-cy="download-as-csv"
              tabindex="0"
            >
              <mat-icon svgIcon="table"></mat-icon>
              CSV
            </a>
            <a
              (click)="downloadPdf()"
              (keydown.enter)="downloadPdf()"
              (keydown.space)="downloadPdf()"
              data-cy="download-as-pdf"
              tabindex="0"
            >
              <mat-icon svgIcon="document"></mat-icon>
              PDF
            </a>
          </ng-container>
        }
      </app-dropdown>
    }
    @if (editMode) {
      <button
        mat-flat-button
        class="button-secondary"
        (click)="restore()"
        data-cy="dashboard-cancel"
      >
        {{ 'DIALOG.BUTTONS.CANCEL' | translate }}
        <mat-icon iconPositionEnd>cancel</mat-icon>
      </button>

      <button
        data-cy="dashboard-save"
        mat-flat-button
        class="button-primary"
        [disabled]="!changesMade"
        (click)="toggleEditMode()"
      >
        {{ 'DASHBOARD.SAVE' | translate }}
        <mat-icon iconPositionEnd svgIcon="ok"></mat-icon>
      </button>
    } @else {
      @if (allowEdit) {
        <button
          data-cy="dashboard-edit"
          mat-flat-button
          class="button-primary"
          (click)="toggleEditMode()"
          [disabled]="isDownloading"
        >
          {{ 'DASHBOARD.EDIT' | translate }}
          <mat-icon iconPositionEnd svgIcon="edit2"></mat-icon>
        </button>
      }
    }

    @if (allowEdit && showSaveAsTemplate()) {
      <button
        data-cy="dashboard-save-as-template"
        mat-flat-button
        class="button-primary"
        (click)="openSaveTemplateModal()"
      >
        {{ 'DASHBOARD.SAVE_AS_TEMPLATE' | translate }}
        <mat-icon iconPositionEnd svgIcon="ok"></mat-icon>
      </button>
    }
  </div>
</section>
